import { defineStore } from 'pinia'
import type { CascaderOption } from 'naive-ui'
import { dirRange } from '../api'
import type { IDirRange } from '../types'
import { useWorkspaceStore } from '@/store'

const defaultValue = {
  content: '',
  folder: undefined,
}

export const findFileStore = defineStore('findFile', () => {
  const workspaceStore = useWorkspaceStore()

  const currentWorkspace = computed(() => {
    return workspaceStore.currentWorkspace
  })

  const fileNodes = ref<CascaderOption[]>([])

  const fileValue = ref<{
    content: string
    folder: number | undefined
  }>({
    ...defaultValue,
  })

  function reset() {
    fileValue.value = {
      ...defaultValue,
    }

    fileNodes.value = []
  }

  const afterEnterFn = (id?: number) => {
    dirRange({
      workspaceId: currentWorkspace.value.workspaceId === -1 ? null : currentWorkspace.value.workspaceId,
      workspaceType: currentWorkspace.value.workspaceType,
    }).then((res) => {
      fileNodes.value = recursionFile(res)

      if (typeof id === 'number') {
        fileValue.value.folder = id
      }
    })
  }

  return {
    reset,
    afterEnterFn,
    fileValue,
    fileNodes,
  }
})
function recursionFile(nodes: IDirRange[], depth = 1): CascaderOption[] {
  return nodes.map((node) => {
    const { id, name, child, level } = node
    const isLeaf = !child?.length
    return {
      label: name,
      value: id,
      depth,
      isLeaf,
      type: level === 1 ? 'folder' : 'file',
      disabled: level !== 2 && isLeaf,
      children: isLeaf ? [] : recursionFile(child, depth + 1),
    }
  })
}
